<template>
    <div v-if="links?.length > 3">
        <div class="flex flex-wrap justify-center -mb-1">
            <template v-for="(link, key) in links" :key="key">
                <div
                    v-if="link.url === null"
                    class="px-4 py-3 mb-1 mr-1 text-sm leading-4 text-gray-400 bg-white border rounded"
                    v-html="label(link)"
                />

                <InertiaLink
                    v-else
                    class="px-4 py-3 mb-1 mr-1 text-sm leading-4 bg-white border rounded hover:bg-gray-50 focus:border-gray-500 focus:text-gray-500"
                    :class="{ 'bg-gray-100 text-gray-600 hover:bg-gray-200 border-gray-800': link.active }"
                    :href="url(link)"
                    v-html="label(link)"
                />
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            links: Array,
        },

        methods: {
            url(link) {
                let newPage = link.url.split('?page=')[1];
                let url = this.$page.props.url;
                let params = new URLSearchParams(url.split('?')[1]);
                params.set('page', newPage);

                return '/' + this.$page.props.path + '?' + params.toString();
            },

            label(link) {
                let label = link.label;
                label = label.replace('Previous', this.$t('Previous'));
                label = label.replace('Next', this.$t('Next'));

                return label;
            },
        }
    }
</script>
